import React, { useEffect } from "react";

import { Stack } from "@mui/material";
import { useCaseListStore } from "../../../cm/Dashboard/FullPages/CaseList/CaseListList/hooks/useCaseListStore";
import { useState } from "react";
import PaginationControlsV2 from "../../../global/PaginationControlsV2";

const Pagination = ({ filters, updateFilter, totalCount }) => {
  const state = useCaseListStore((state) => state);
  const currentOffset = filters.get("offset");
  const currentLimit = filters.get("limit");
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(Math.round(currentOffset / currentLimit) + 1);
  }, [currentOffset, currentLimit]);

  const handlePageChange = (_, value) => {
    setPage(value);
    updateFilter("offset", (value - 1) * currentLimit);
  };
  return !totalCount ? (
    ""
  ) : (
    <div id="Case-Search-Pagination">
      {!state.fetchIsLoading && (
        <div className="flex flex-row justify-center">
          <div className={`flex justify-center py-2 md:px-0 px-0 w-full`}>
            <Stack alignItems={"center"}>
              <PaginationControlsV2
                alignment={"center"}
                resultCount={totalCount}
                handleChange={handlePageChange}
                currentPage={page}
                resultLimit={currentLimit}
              />
            </Stack>
          </div>
        </div>
      )}
    </div>
  );
};
export default Pagination;